import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Actions from '../../../../actions'
import { find } from 'lodash'
import TeamMemberEditForm from '../../../../components/forms/screens/TeamMemberEditForm'
import dayjs from 'dayjs'
import { withRouter } from '../../../../withRouter'
import { history } from '../../../../store'

export class TeamMemberEditScreen extends PureComponent {
  componentDidMount() {
    if (this.props.profile) {
      this.populateForm(this.props.profile)
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.profile?.id && this.props.profile?.id) {
      this.populateForm(this.props.profile)
    }
  }

  populateForm = (profile) => {
    this.props.addForm({
      ...profile,
      dateOfBirth: profile.dateOfBirth
        ? dayjs(profile.dateOfBirth).format('DD-MM-YYYY')
        : null,
      startDate: profile.startDate
        ? dayjs(profile.startDate).format('DD-MM-YYYY')
        : null,
      endDate: profile.endDate
        ? this.props.teamMemberEnabled &&
          dayjs(profile.endDate).format('DD-MM-YYYY')
        : null,
      homes: profile.homes?.length
        ? profile.homes
        : profile.home
        ? [profile.home]
        : null,
    })
  }

  render() {
    const { profile } = this.props
    if (!profile) return null

    return (
      <TeamMemberEditForm
        router={history}
        teamMemberEnabled={this.props.teamMemberEnabled}
        hasRota={this.props.hasRota}
        flagsRosteringChangeManagementEnabled={
          this.props.flagsRosteringChangeManagementEnabled
        }
        queryClient={this.props.queryClient}
        groupAccessManagementEnabled={this.props.groupAccessManagementEnabled}
        rolesAndPermissionsEnabled={this.props.rolesAndPermissionsEnabled}
      />
    )
  }
}

const FORM_ID = 'editTeamMember'

TeamMemberEditScreen.propTypes = {
  addForm: PropTypes.func,
  profile: PropTypes.object,
  teamMemberEnabled: PropTypes.bool,
  gpConnectPart2Enabled: PropTypes.bool,
  hasRota: PropTypes.bool,
  flagsRosteringChangeManagementEnabled: PropTypes.bool,
}

const mapStateToProps = (state, props) => {
  const carer = find(state.data.carers, {
    id: props.router.params.id,
  })
  return {
    profile: {
      gpConnectPermission: false,
      ...carer,
    },
  }
}

const mapDispatchToProps = (dispatch) => ({
  addForm: (profile) =>
    dispatch(
      Actions.addForm({
        formId: FORM_ID,
        initial: profile,
      })
    ),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TeamMemberEditScreen)
)
